import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import ApproveRepository from '../Repositories/ApproveRepository'

class AppproveBloc {

    rejectChannel = new Subject()
    typeChannel = new Subject()
    employeeListChannel = new Subject();
    detailChannel = new Subject()
    repository = new ApproveRepository()

    constructor() {
        this.rejectChannel.next({ status: apiResponse.INITIAL })
        this.typeChannel.next({ status: apiResponse.INITIAL })
        this.employeeListChannel.next({ status: apiResponse.INITIAL })
        this.detailChannel.next({ status: apiResponse.INITIAL })
    }

    fetchDetail = async (query, cancelToken) => {
        this.detailChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailChannel.next({ status: apiResponse.ERROR, data: error })
            })   
        } catch (error) {
            console.log('Channel Unsubscribed')
        }
    }

    fetchEmployeeList = async (query) => {
        this.employeeListChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchEmployeeList(query).then((result) => {
                this.employeeListChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.employeeListChannel.next({ status: apiResponse.ERROR, data: error })
            })           
        } catch (error) {
            console.log('Channel Unsubscribed')
        }
    }

    fetchReject = async (query) => {
        this.rejectChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchReject(query).then((result) => {
                this.rejectChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.rejectChannel.next({ status: apiResponse.ERROR, data: error })
            })   
        } catch (error) {
            console.log('Channel Unsubscribed')
        }
    }

    fetchType = async (query, cancelToken) => {
        this.typeChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchType(query, cancelToken).then((result) => {
                this.typeChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.typeChannel.next({ status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('Channel Unsubscribed')
        }
    }

}

export default AppproveBloc